import { ApiErrorCode } from '@orn/global/errors/apiErrorCodes.js';

import { extractErrorCode } from '../../utils/apollo/error';

import type { RecordPaneStatus } from '../../components/entity/RecordPane';
import type { ApolloError } from '@apollo/client';

export interface ITransactionPageRead {
  loading: boolean;
  error: ApolloError | undefined;
  /** Whether the read has a transaction to draw. */
  hasTransaction: boolean;
}

/**
 * Which shell state the page is in. `getTransaction` is non-nullable on the
 * wire — a missing or hidden transaction comes back as a coded GraphQL error,
 * not a null — so not-found is read off the error code. A read that never ran
 * (no id) is not-found too: the shell's copy covers it.
 */
export function resolveTransactionPageStatus({
  loading,
  error,
  hasTransaction,
}: ITransactionPageRead): RecordPaneStatus {
  if (hasTransaction) {
    return 'ready';
  }
  if (loading) {
    return 'loading';
  }
  if (error) {
    return isTransactionNotFound(error) ? 'not-found' : 'error';
  }
  return 'not-found';
}

function isTransactionNotFound(error: ApolloError): boolean {
  return error.graphQLErrors.length > 0 && extractErrorCode(error.graphQLErrors) === ApiErrorCode.TRANSACTION_NOT_FOUND;
}
